/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ViewContainerRef, ComponentFactory } from '@angular/core';

import { PopupOutput, PopupOutputType, PopupCommunication } from './interfaces';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

//TODO - move elsewhere
export class Popup {
	constructor(
		private viewContainer: ViewContainerRef,
		private componentFactory: ComponentFactory<any>,
		public wrapper: (viewContainer: ViewContainerRef) => ViewContainerRef
	) {}
	private shutdownSubject = new Subject<void>();

	private _output$ = new Subject<PopupOutput>();
	public output$ = this._output$.asObservable();

	public open(inputData?: any) {
		const revisedViewContainer = this.wrapper(this.viewContainer);
		// this.viewContainer.clear();
		revisedViewContainer.clear();
		const componentRef = revisedViewContainer.createComponent(this.componentFactory);

		const component = <PopupCommunication>componentRef.instance;
		component.popupInit(inputData);
		component.output$.pipe(takeUntil(this.shutdownSubject)).subscribe(this._output$);

		this.output$.pipe(takeUntil(this.shutdownSubject)).subscribe({ complete: () => this.removeView() });
	}

	//to close it externally
	public close() {
		this._output$.next({
			type: PopupOutputType.canceled,
		});
		this._output$.complete();
	}

	//this should only be called when the output observable completes
	private removeView() {
		// this._output$.complete();
		this.viewContainer.clear();
	}
}
